// src/snippetsApi.ts
// Thin client for /api/snippets/* — see api/src/snippets.ts.

import { apiFetch } from './api';
import type { Snippet, SnippetCreate, SnippetUpdate } from '@ring/shared/snippets';

export type { Snippet };

export async function listSnippets(): Promise<Snippet[]> {
  return (await apiFetch<{ snippets: Snippet[] }>('/api/snippets', { method: 'GET' })).snippets;
}

export function createSnippet(body: SnippetCreate): Promise<Snippet> {
  return apiFetch<Snippet>('/api/snippets', { method: 'POST', body: JSON.stringify(body) });
}

export function updateSnippet(snippetId: string, update: SnippetUpdate): Promise<Snippet> {
  return apiFetch<Snippet>(`/api/snippets/${snippetId}`, { method: 'PATCH', body: JSON.stringify(update) });
}

export function deleteSnippet(snippetId: string): Promise<void> {
  return apiFetch<void>(`/api/snippets/${snippetId}`, { method: 'DELETE' });
}
